module.exports = __webpack_public_path__ + "static/logo-vertical-dark-2000x1643-9e5e8551d3b3e33cdf5d5ee5b2d2b5b7.png";